import React, {Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import RestaCompartido from './RestaCompartido';

import { setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../../actions/estadoEjercicioActions';

const instrucciones = 'Resuelve la resta mentalmente.';
const miniInstrucciones = 'Resuelve la resta mentalmente.';

const M78 = () => {

    const dispatch = useDispatch();

    const [data, setData] = useState([]);
    const [indexes, setIndexes] = useState(0);

    useEffect(() => {
        const numeros = [10,20,30,40,50,60,70,80,90];

        function shuffle (array) {
            let currentIndex = array.length, randomIndex;
          
            // While there remain elements to shuffle...
            while (currentIndex !== 0) {
          
              // Pick a remaining element...
              randomIndex = Math.floor(Math.random() * currentIndex);
              currentIndex--;
          
              // And swap it with the current element.
              [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }
            return array;
        }

        const randomNumeros = shuffle(numeros);

        const modelo = [
            {id:'1', cantidad_1:randomNumeros[0], cantidad_2:10},
            {id:'2', cantidad_1:randomNumeros[1], cantidad_2:10},
            {id:'3', cantidad_1:randomNumeros[2], cantidad_2:10},
            {id:'4', cantidad_1:randomNumeros[3], cantidad_2:10},
            {id:'5', cantidad_1:randomNumeros[4], cantidad_2:10}
        ]
        setData(modelo);
        setIndexes(modelo.length);
        dispatch(setearEjercicioAction('M78') );
        dispatch(setearUrlAnteriorAction('matematica/calculo/resta/calculo-mental/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Fragment>
            <RestaCompartido data={data} indexes={indexes} ejercicio="M78" tipo={"decena"} instrucciones={instrucciones} miniInstrucciones={miniInstrucciones} ayuda={true} width={"12vw"} inp={"27vw"} color={"#FF9B2A"} />
        </Fragment>
    );
}
 
export default M78;